import { registerPlugin } from '@capacitor/core';
const ThaiIDReader = registerPlugin('ThaiIDReader', {
    web: () => import('./web').then(m => new m.ThaiIDReaderWeb()),
});
export * from './definitions';
export { ThaiIDReader };
//# sourceMappingURL=index.js.map